import React from 'react';
import { Typography, Box } from '@mui/material';

const IAF = () => {
  return (
    <Box>
      <Typography variant="h5">IAF Form</Typography>
    </Box>
  );
};

export default IAF;
